import { Footer, PageNumber, Paragraph, TextRun } from "docx";
import {
  defaultFontNormal,
  indentationNormal,
  rightTabStop,
  smallFontSize,
} from "../utils/styling";
import { getTodayDate } from "../utils/WordExportUtils";

export const getFooter = (extraFooter, isClientFacing = true) => {
  const todayDate = getTodayDate();

  return {
    footers: {
      default: new Footer({
        children: [
          ...(extraFooter ? [extraFooter] : []),
          new Paragraph({
            tabStops: [rightTabStop],
            ...indentationNormal,
            children: [
              new TextRun({
                text: "Corporate Interest Restriction",
                ...defaultFontNormal,
                ...smallFontSize,
                break: 1,
              }),
              new TextRun("\t"),
              new TextRun({
                text: `${todayDate}`,
                ...defaultFontNormal,
                ...smallFontSize,
              }),
            ],
          }),
          new Paragraph({
            tabStops: [rightTabStop],
            ...indentationNormal,
            children: [
              new TextRun({
                text: isClientFacing
                  ? "Strictly Private and Confidential"
                  : "PwC Strictly Private and Confidential",
                ...defaultFontNormal,
                ...smallFontSize,
              }),
              new TextRun("\t"),
              new TextRun({
                ...defaultFontNormal,
                ...smallFontSize,
                children: [PageNumber.CURRENT],
              }),
            ],
          }),
        ],
      }),
    },
  };
};
